import { Action } from '@ngrx/store';

export enum FriendRequestsActionType {
    LOAD_FRIEND_REQUESTS = '[Messenger/FriendRequests] LOAD_FRIEND_REQUESTS',
    LOAD_FRIEND_REQUESTS_FAILED = '[Messenger/FriendRequests] LOAD_FRIEND_REQUESTS_FAILED',
    LOAD_FRIEND_REQUESTS_SUCCEEDED = '[Messenger/FriendRequests] LOAD_FRIEND_REQUESTS_SUCCEEDED',
    ACCEPT_FRIEND_REQUEST = '[Messenger/FriendRequests] ACCEPT_FRIEND_REQUEST',
    ACCEPT_FRIEND_REQUEST_FAILED = '[Messenger/FriendRequests] ACCEPT_FRIEND_REQUEST_FAILED',
    ACCEPT_FRIEND_REQUEST_SUCCEEDED = '[Messenger/FriendRequests] ACCEPT_FRIEND_REQUEST_SUCCEEDED',
    DENY_FRIEND_REQUEST = '[Messenger/FriendRequests] DENY_FRIEND_REQUEST',
    DENY_FRIEND_REQUEST_FAILED = '[Messenger/FriendRequests] DENY_FRIEND_REQUEST_FAILED',
    DENY_FRIEND_REQUEST_SUCCEEDED = '[Messenger/FriendRequests] DENY_FRIEND_REQUEST_SUCCEEDED',
}


export class LoadFriendRequestsAction implements Action {
    readonly type = FriendRequestsActionType.LOAD_FRIEND_REQUESTS;
    constructor() {}
}

export class LoadFriendRequestsFailedAction implements Action {
    readonly type = FriendRequestsActionType.LOAD_FRIEND_REQUESTS_FAILED;
    constructor(public error: any) {}
}

export class LoadFriendRequestsSucceededAction implements Action {
    readonly type = FriendRequestsActionType.LOAD_FRIEND_REQUESTS_SUCCEEDED;
    constructor(public invitations: any) {}
}

export class AcceptFriendRequestAction implements Action {
    readonly type = FriendRequestsActionType.ACCEPT_FRIEND_REQUEST;
    constructor(public userID: string) {}
}

export class AcceptFriendRequestFailedAction implements Action {
    readonly type = FriendRequestsActionType.ACCEPT_FRIEND_REQUEST_FAILED;
    constructor(public error: any) {}
}

export class AcceptFriendRequestSucceededAction implements Action {
    readonly type = FriendRequestsActionType.ACCEPT_FRIEND_REQUEST_SUCCEEDED;
    constructor(public userID: string) {}
}

export class DenyFriendRequestAction implements Action {
    readonly type = FriendRequestsActionType.DENY_FRIEND_REQUEST;
    constructor(public userID: string) {}
}

export class DenyFriendRequestFailedAction implements Action {
    readonly type = FriendRequestsActionType.DENY_FRIEND_REQUEST_FAILED;
    constructor(public error: any) {}
}

export class DenyFriendRequestSucceededAction implements Action {
    readonly type = FriendRequestsActionType.DENY_FRIEND_REQUEST_SUCCEEDED;
    constructor(public userID: string) {}
}

export type FriendRequestsAction
    = LoadFriendRequestsAction
    | LoadFriendRequestsFailedAction
    | LoadFriendRequestsSucceededAction
    | AcceptFriendRequestAction
    | AcceptFriendRequestFailedAction
    | AcceptFriendRequestSucceededAction
    | DenyFriendRequestAction
    | DenyFriendRequestFailedAction
    | DenyFriendRequestSucceededAction;
